import { render, staticRenderFns } from "./otherAct.vue?vue&type=template&id=5e4fd63c&scoped=true&"
import script from "./otherAct.vue?vue&type=script&lang=js&"
export * from "./otherAct.vue?vue&type=script&lang=js&"
import style0 from "./otherAct.vue?vue&type=style&index=0&id=5e4fd63c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4fd63c",
  null
  
)

export default component.exports